module.exports = __webpack_public_path__ + "img/電気回路_3_8_3.8f301315.png";